
// **************  资源库  ****************
// 获取资源库列表
export const RESOURCE_GET_LIST = 'RESOURCE_GET_LIST';

// 修改资源库资源收藏状态
export const RESOURCE_MODIFY_COLLECTION = 'RESOURCE_MODIFY_COLLECTION';



// WEBPACK FOOTER //
// ./src/views/index/store/types/types_resource.js